import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import ServiceRequestDetails from '@/ui/pages/ServiceRequestDetails/ServiceRequestDetails';

// HS-1548: one service request. `Request.View` or `Request.Manage` opens it; the decision
// buttons additionally need `serviceRequest.decide` and are gated on the page.
export const Route = createFileRoute('/_dashboard/requests/$id')({
  beforeLoad: requireRoute('/requests/$id'),
  component: ServiceRequestDetails,
});
